import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Title = ({ text, url }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="w-full flex justify-between items-center">
      <span className="text-lg font-semibold">
        {text}
      </span>
      {url &&
        <span className="text-primary font-semibold" onClick={() => navigate(url)}>
          {t('general.see_all')}
        </span>
      }
    </div>
  )
}

export default Title;